import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    announcementId: String
  }

  connect() {
    // Modal is shown via CSS class, just prevent background scrolling
    document.body.style.overflow = 'hidden'
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    const modal = this.element
    modal.classList.remove('show')
    document.body.style.overflow = '' // Restore scrolling
    
    // Mark announcement as viewed
    if (this.announcementIdValue) {
      this.markAsViewed()
    }
  }

  markAsViewed() {
    const announcementId = this.announcementIdValue
    if (!announcementId) return
    
    const url = `/announcements/${announcementId}/mark_as_viewed`
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    
    if (!csrfToken) {
      console.error('CSRF token not found')
      return
    }
    
    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    })
    .then(response => {
      if (response.ok) {
        console.log('Announcement marked as viewed')
      } else {
        console.error('Failed to mark announcement as viewed:', response.status, response.statusText)
      }
    })
    .catch(error => {
      console.error('Error marking announcement as viewed:', error)
    })
  }

  // Close on overlay click
  closeOnOverlay(event) {
    if (event.target.classList.contains('announcement-modal-overlay')) {
      this.close()
    }
  }
}

